<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload()" />
    </div>
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期</label>
              <el-date-picker
                style="width: 100%"
                v-model="search.RangeDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
              >
                >
              </el-date-picker>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">面談流程</label>
              <el-select
                style="width: 100%"
                clearable
                filterable
                placeholder="請選擇"
                v-model="search.BaseFlowGuid"
              >
                <el-option
                  v-for="item in flowList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">招募窗口</label>
              <el-select
                style="width: 100%"
                filterable
                clearable
                placeholder="請選擇"
                v-model="search.ContactPersonGuid"
              >
                <el-option
                  v-for="item in contactList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">姓名</label>
              <input
                type="text"
                id="search-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.Name"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">應徵職務</label>
              <input
                type="text"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.ManpowerDemandName"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <button
              type="button"
              @click="getData()"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
            >
              {{ i18n("Buttons.Search") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                search = {
                  RangeDate: search.RangeDate,
                }
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="text-right mb-2">
      <el-button type="primary" size="small" @click="exportExcel"
        >匯出</el-button
      >
    </div>

    <div class="yahome-table-wrap">
      <el-table v-if="tableData" :data="tableData.ReportFlows" height="450px">
        <el-table-column prop="Name" label="姓名" sortable></el-table-column>
        <el-table-column
          prop="IdNo"
          label="身分證字號"
          sortable
        ></el-table-column>
        <el-table-column
          prop="ManpowerDemandName"
          label="應徵職務"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="ContactPersonName"
          label="招募窗口"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'ContactPersonName')"
        ></el-table-column>
        <el-table-column
          prop="HrManagerName"
          label="HR主管"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'HrManagerName')"
        >
        </el-table-column>
        <el-table-column
          prop="InterviewManagerName"
          label="面談主管"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'InterviewManagerName')"
        >
        </el-table-column>
        <el-table-column
          prop="BaseFlowName"
          label="使用流程"
          width="120"
          sortable
          :sort-method="(a, b) => defaultSort(a, b, 'BaseFlowName')"
        >
        </el-table-column>
        <el-table-column
          prop="InvitationTime"
          label="面談日期"
          width="120"
          sortable
          :formatter="dateFormatter"
        >
        </el-table-column>
        <el-table-column
          prop="TemporaryTime"
          label="臨時到廠時間"
          width="120"
          sortable
          :formatter="timeFormatter"
        >
        </el-table-column>
        <el-table-column
          prop="CheckInTime"
          label="報到時間"
          width="120"
          sortable
          :formatter="timeFormatter"
          :sort-method="(a, b) => defaultSort(a, b, 'CheckInTime')"
        >
        </el-table-column>

        <template
          v-for="(DynamicStageHeader, index) in tableData.DynamicStageHeader"
        >
          <el-table-column
            :key="index + 'startTime'"
            width="90"
            :label="DynamicStageHeader.Name"
            :formatter="filterStartTime"
          >
            <template slot="header">
              {{ DynamicStageHeader.Name }}-開始時間
            </template>
          </el-table-column>
          <el-table-column
            :key="index + 'endTime'"
            width="90"
            :label="DynamicStageHeader.Name"
            :formatter="filterEndTime"
          >
            <template slot="header">
              {{ DynamicStageHeader.Name }}-結束時間
            </template>
          </el-table-column>

          <el-table-column
            :key="index + 'person'"
            v-if="DynamicStageHeader.Type === 2"
            width="90"
            :label="DynamicStageHeader.Name"
            :formatter="filterPerson"
          >
            <template slot="header">
              {{ DynamicStageHeader.Name }}-{{
                DynamicStageHeader.InterviewUserType
              }}
            </template>
          </el-table-column>

          <el-table-column
            :key="index + 'IsOverTime'"
            width="90"
            :label="DynamicStageHeader.Name"
            :formatter="filterIsOverTime"
          >
            <template slot="header">
              {{ DynamicStageHeader.Name }}-是否超時
            </template>
          </el-table-column>
        </template>

        <el-table-column
          prop="FinishTime"
          label="離場時間"
          width="120"
          sortable
          :formatter="timeFormatter"
          :sort-method="(a, b) => defaultSort(a, b, 'FinishTime')"
        >
        </el-table-column>

        <el-table-column
          prop="IsForceCancel"
          label="強制結案"
          width="120"
          sortable
          :formatter="timeFormatter"
        >
          <template slot-scope="props">
            <span v-if="props.row.IsForceCancel === true">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>

        <el-table-column prop="FinishRemark" label="結案備註" sortable>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "RoomScheduleSetting",

  components: {},
  data() {
    return {
      search: {
        RangeDate: [new Date(), new Date()],
      },
      flowList: [],
      contactList: [],

      isShowDetail: false,
      startPickerOptions: {
        disabledDate: null,
      },
      endPickerOptions: {
        disabledDate: null,
      },

      tableData: null,
    };
  },

  methods: {
    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },

    getData() {
      const vm = this;
      vm.tableData = null;
      vm.$store.dispatch("updateLoading", true);

      let params = {
        ...vm.search,
        InvitationStartTime: vm.search.RangeDate
          ? vm.search.RangeDate[0]
          : null,
        InvitationEndTime: vm.search.RangeDate ? vm.search.RangeDate[1] : null,
      };

      vm.$api.InterviewSch.getReportFlow(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.tableData = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getReportFlowFlowOption() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);

      vm.$api.InterviewSch.getReportFlowFlowOption()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.flowList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getReportFlowContactOption() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);

      vm.$api.InterviewSch.getReportFlowContactOption()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.contactList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    filterStartTime(row, column) {
      let haveItem = row.StagesEndTimeList.find((item) => {
        return item.Name === column.label;
      });

      if (haveItem && haveItem.IsDeleted) {
        return "已Pass";
      }

      if (haveItem && haveItem.StartTime) {
        return this.dayjs(haveItem.StartTime).format("HH:mm");
      }

      return "-";
    },

    filterEndTime(row, column) {
      let haveItem = row.StagesEndTimeList.find((item) => {
        return item.Name === column.label;
      });

      if (haveItem && haveItem.IsDeleted) {
        return "已Pass";
      }

      if (haveItem && haveItem.EndTime) {
        return this.dayjs(haveItem.EndTime).format("HH:mm");
      }

      return "-";
    },

    filterPerson(row, column) {
      let haveItem = row.StagesEndTimeList.find((item) => {
        return item.Name === column.label;
      });

      if (haveItem) {
        return haveItem.SupervisorName;
      } else {
        return "-";
      }
    },

    filterIsOverTime(row, column) {
      let haveItem = row.StagesEndTimeList.find((item) => {
        return item.Name === column.label;
      });

      if (haveItem && haveItem.IsOverTime) {
        return "是";
      }
    },

    dateFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    timeFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("HH:mm");
      } else {
        return "";
      }
    },

    exportExcel() {
      const vm = this;
      let params = {
        ...vm.search,
        InvitationStartTime: vm.search.RangeDate
          ? vm.search.RangeDate[0]
          : null,
        InvitationEndTime: vm.search.RangeDate ? vm.search.RangeDate[1] : null,
      };
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.exportFlowExcel(params).then((response) => {
        if (response.data.ErrorMessage) {
          this.$notify({
            message: response.data.ErrorMessage,
            type: "error",
          });
        } else {
          let filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );

          let blob = new Blob([response.data]);
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = filename;
          link.click();

          window.URL.revokeObjectURL(url);
        }
        vm.$store.dispatch("updateLoading", false);
      });
    },

    //欄位排序
    //因有null項目會導致套件排序失效顧加上該method 解決null問題
    defaultSort(a, b, prop) {
      if (a[prop] === null) {
        return 1;
      } else {
        return a[prop] < b[prop] ? 1 : -1;
      }
    },

    reload() {
      this.getReportFlowFlowOption();
      this.getReportFlowContactOption();
      this.getData();
    },
  },
  watch: {
    "search.InvitationStartTime": function () {
      const startDate = this.search.InvitationStartTime;
      let days = this.dayjs(this.search.InvitationStartTime);

      if (startDate) {
        this.endPickerOptions = {
          disabledDate(date) {
            return date < days;
          },
        };
      }
    },
    "search.InvitationEndTime": function () {
      const endDate = this.search.InvitationEndTime;
      let days = this.dayjs(this.search.InvitationEndTime);

      if (endDate) {
        this.startPickerOptions = {
          disabledDate(date) {
            return date > days;
          },
        };
      }
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },

  created() {
    this.getReportFlowFlowOption();
    this.getReportFlowContactOption();

    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.name-link {
  background-color: #d9e3ff;
  padding: 3px 15px;
  border-radius: 25px;
  display: inline-block;
  cursor: pointer;
  &.female {
    background-color: #ffd4d4;
  }
}
.p-card {
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;

  margin: 10px;
  .person-info {
    display: flex;
    padding: 20px;
    position: relative;
    z-index: 2;
    margin-bottom: -20px;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 5px 5px 0 rgba(#000, 0.15);
      margin-right: 15px;
    }
    .info {
      flex: 1;
      .name {
        font-size: 1.5em;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .id {
        font-size: 0.8em;
      }
      .job {
        background-color: #5380f7;
        color: #fff;
        padding: 3px 15px;
        font-size: 0.8em;
        margin-top: 17px;
        border-radius: 25px;
        display: inline-block;
      }
    }
  }
  .job-info {
    background-color: #d9e3ff;
    padding: 20px;
    position: relative;
    &::after {
      content: "";
      width: 200%;
      height: 100px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #d9e3ff;
      transform: rotate(-7deg);
      transform-origin: top left;
    }
    label {
      background-color: #fff;
      border-radius: 25px;
      padding: 3px 5px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .svg-wrap {
        background-color: #5380f7;
        margin-right: 5px;
        border-radius: 50%;
        padding: 5px;
        width: 30px;
        height: 30px;
        svg {
          width: 100%;
          height: 100%;
          fill: #fff;
          position: relative;
          top: -4px;
        }
      }
      position: relative;
      z-index: 2;
      /deep/ .el-input__inner {
        border: none !important;
      }
      span {
        line-height: 40px;
        margin-left: 10px;
      }
    }
  }
}
</style>
